/**
 * Relay-load contract writes for the charting stage. Contracts are read from
 * the site dashboard snapshot; only the create/edit/delete round trips live
 * here.
 *
 * Contains:
 * - createRelayLoadContract / editRelayLoadContract / deleteRelayLoadContract
 */
import { createAsyncThunk } from '@reduxjs/toolkit';
import * as ContractsApi from '@sophocles/api/charting';

export const createRelayLoadContract = createAsyncThunk(
  'charting/contracts/create',
  async (payload, { rejectWithValue }) => {
    try {
      const data = await ContractsApi.postRelayLoadContract(payload);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const editRelayLoadContract = createAsyncThunk(
  'charting/contracts/edit',
  async ({ id, ...payload }, { rejectWithValue }) => {
    try {
      const data = await ContractsApi.patchRelayLoadContract(id, payload);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const deleteRelayLoadContract = createAsyncThunk(
  'charting/contracts/delete',
  async (id, { rejectWithValue }) => {
    try {
      return await ContractsApi.deleteRelayLoadContract(id);
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);
